import type { BulkEvent } from '@Common/types/analytics/bulk_events';

export const StorageKey = 'bo_external_events';

/**
 * Hard cap on the queue. If the backend is unreachable for a long time we would otherwise
 * grow localStorage until it throws, which would take the whole app down with it.
 * Oldest events are dropped first: the freshest ones are the ones worth investigating.
 */
export const MAX_STORED_EVENTS = 500;

export const getStoredEvents = (): BulkEvent[] => {
  try {
    const raw = localStorage.getItem(StorageKey);
    const parsed: unknown = raw ? JSON.parse(raw) : [];

    return Array.isArray(parsed) ? (parsed as BulkEvent[]) : [];
  } catch {
    // corrupted payload (truncated write, manual edit): start over rather than break the app
    localStorage.removeItem(StorageKey);

    return [];
  }
};

export const setStoredEvents = (events: BulkEvent[]): void => {
  try {
    localStorage.setItem(StorageKey, JSON.stringify(events.slice(-MAX_STORED_EVENTS)));
  } catch {
    // quota exceeded: drop the backlog, keep the app running
    localStorage.removeItem(StorageKey);
  }
};

export const storeEvent = (event: BulkEvent): void => {
  setStoredEvents([...getStoredEvents(), event]);
};

export const removeStoredEvents = (sentIds: Set<string>): void => {
  setStoredEvents(getStoredEvents().filter((event) => !sentIds.has(event.id)));
};
